<form [formGroup]="form" (ngSubmit)="onSubmit()" class="my-4">
    <!-- <div class="comment-form-title">Deja un comentario</div> -->
    <div class="row">
        <div class="col-6">
            <input type="text" class="form-control" formControlName="username" placeholder="Nombre(s)"
                [class.is-invalid]="campoNoValido('username') && username">
            <small class="text-danger" *ngIf="campoNoValido('username')">
                <span *ngIf="username.errors.required">
                    El nombre es requerido
                </span>
                <span *ngIf="username.errors.pattern">
                    Solo se admiten letras
                </span>
            </small>
        </div>

        <div class="col-6">
            <input type="text" class="form-control" formControlName="lastname" placeholder="Apellido paterno"
                [class.is-invalid]="campoNoValido('lastname')">
            <small class="text-danger" *ngIf="campoNoValido('lastname')">
                <span *ngIf="lastname.errors.required">
                    El apellido paterno es requerido
                </span>
                <span *ngIf="lastname.errors.pattern">
                    Solo se admiten letras
                </span>
            </small>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-6">
            <input type="text" class="form-control" formControlName="surname" placeholder="Apellido materno"
                [class.is-invalid]="campoNoValido('surname')">
            <small class="text-danger" *ngIf="campoNoValido('surname')">
                <span *ngIf="surname.errors.required">
                    El apellido materno es requerido
                </span>
                <span *ngIf="surname.errors.pattern">
                    Solo se admiten letras
                </span>
            </small>
        </div>
        <div class="col-6">
            <input type="email" class="form-control" formControlName="email" placeholder="Correo electrónico"
                [class.is-invalid]="campoNoValido('email')&& email">
            <small class="text-danger" *ngIf="campoNoValido('email')">
                <span *ngIf="email.errors.required">
                    El email es requerido
                </span>
                <span *ngIf="email.errors.email">
                    Ingrese un email valido
                </span>
            </small>

        </div>
    </div>

    <div class="row mt-2">
        <div class="col-12">
            <textarea class="form-control" formControlName="body" rows="10" placeholder="Comentario"
                [class.is-invalid]="campoNoValido('body') && body"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('body')">
                <span *ngIf="body.errors.required">
                    El comentario es requerido
                </span>
                <span *ngIf="body.errors.pattern">
                    No ingrese caracteres especiales
                </span>
                <span *ngIf="body.errors.minlength">
                    El comentario debe al menos contener 5 caracteres
                </span>
                <span *ngIf="body.errors.maxlength">
                    El comentario com maximo debe contener 2024 caracteres
                </span>
            </small>
        </div>
    </div>

    <div class="my-2">
        <button class="btn btn-success btn-sm mr-2" type="submit" [disabled]="form.invalid">
            {{ submitLabel }}
        </button>
        <button *ngIf="hasCancelButton" type="button" class="btn btn-danger btn-sm" (click)="handleCancel.emit()">
            Cancelar
        </button>
    </div>

</form>